import gql from 'graphql-tag';

export const createMerchantUserByAdmin = gql`
  mutation createMerchantUserByAdmin($merchantId: Int!, $input: CreateUserInput!) {
    createMerchantUserByAdmin(merchantId: $merchantId, input: $input) {
      id
      username
    }
  }
`;

export const updateMerchantUserByAdmin = gql`
  mutation updateMerchantUserByAdmin($input: UpdateUserInput!) {
    updateMerchantUserByAdmin(input: $input) {
      id
      username
    }
  }
`;

export const removeMerchantUserByAdmin = gql`
  mutation removeMerchantUserByAdmin($id: Int!) {
    removeMerchantUserByAdmin(id: $id) {
      id
      username
    }
  }
`;
